<template>
  <section class="ChatWindowPage">
    <h1>Chat id: {{ chatId }}</h1>
  </section>
</template>

<script>
export default {
  name: 'ChatWindowPage',
  computed: {
    chatId() {
      return this.$route.params.chatId;
    },
  },
  meta: {
    title: 'Chat',
  },
};
</script>
